// Agency Routing Types
export const RESPONSIBLE_AGENCY = 'RESPONSIBLE';
export const NOTIFIED_AGENCY = 'NOTIFIED';

// Toast Messages
export const RESPONSIBLE_AGENCY_TOAST_MESSAGE = 'New Active Assailant Alert';
export const NOTIFIED_AGENCY_TOAST_MESSAGE =
  'Information Only: Active Assailant Alert in ';
export const RESPONSIBLE_AGENCY_TRAIN_INCIDENT_TOAST_MESSAGE =
  'New Train Derailment Alert';
export const NOTIFIED_AGENCY_TRAIN_INCIDENT_TOAST_MESSAGE =
  'Information Only: Train Derailment Alert in ';

export const TEST_TRAIN_ALERT_TOAST_MESSAGE = 'New TEST Train Derailment Alert';
export const TEST_AA_ALERT_TOAST_MESSAGE = 'New TEST Active Assailant Alert';

export const TEST_ALERT_TOAST_MESSAGE = 'New TEST Alert';
